/**
 * The default hl7 v2 delimiters
 */
module.exports = {
  field: '|', // |
  component: '^', // ^
  repetition: '~', // ~
  escape: '\\', // \
  subComponent: '&' // &
};
